import { getStepFieldValue, getStepDocument } from '../utils';
//import useAutomation from '../../../automation';
//import { AUTOMATION_ACTION_TYPE } from '../../../automation';
import { useSelector, useDispatch } from 'react-redux';
import { getDataLinkPath } from '../../../page/utils';
import useParse from '../../../parse';
import {
  serverTimestamp,
  updateDoc,
  doc,
  deleteField,
  Timestamp,
  getFirestore
} from 'firebase/firestore';
import useDataLinkDatabase from '../../../database/datalink';
import { getFormValues, logDocumentEvent } from '../utils';
import { keyUpdatedAction } from '../../../../redux/actions/local';

const useUpdate = () => {
  //const { onDocumentAction } = useAutomation();
  const user = useSelector(state => state.User);
  const { dataLinks } = useSelector(state => state.DataLinks);
  const dispatch = useDispatch();
  const { parse } = useParse();
  const { getDb, getDatabaseId } = useDataLinkDatabase();

  const updateDocument = async ({
    page,
    sequence,
    step,
    documents,
    selections,
    local,
    data,
    params,
    history
  }) => {
    const pageDataLink = page.dataLinks.find(
      d => d.dataLinkId === step.updateDocumentDataLinkId
    );

    if (!pageDataLink) {
      return {
        error: `seqeuence "${sequence.name}", step: ${step.name} cannot be processed because the data link with id ${step.updateDocumentDataLinkId} set against the step cannot be found.`
      };
    }

    const contentType = pageDataLink.dataLink.contentType;

    const document = getStepDocument({
      selections,
      dataLinkId: step.updateDocumentDataLinkId,
      documents
    });

    if (!document) {
      return {
        error: `data link "${pageDataLink.dataLink.name}" does not have a selected document that can be updated by sequence "${sequence.name}", step: ${step.name}"`
      };
    }

    let inputs = {};
    let newData = {};

    if (step.formId?.trim().length > 0) {
      inputs = getFormValues({
        formId: step.formId,
        returnObject: true
      });

      Object.keys(inputs).forEach(k => {
        if (!k || k === '') {
          delete inputs[k];
        }
      });

      newData = { ...document };
      if (
        inputs !== undefined &&
        Object.keys(inputs).length > 0 &&
        step.formId?.trim().length > 0
      ) {
        newData = { ...newData, ...inputs };
      }
    }

    step.fields
      ?.filter(f => f.value !== '{delete}')
      .forEach(stepField => {
        const stepFieldValue = getStepFieldValue({
          stepField,
          document,
          selections,
          documents,
          user,
          local,
          history,
          data: {
            ...data,
            ...inputs
          },
          dataLinks,
          params
        });
        if (
          Object.prototype.toString.call(stepFieldValue) === '[object Object]'
        ) {
          newData[
            stepField.dynamicFieldName?.trim().length > 0
              ? stepField.dynamicFieldName
              : stepField.name
          ] = stepFieldValue;
        } else if (stepField.dynamicFieldName?.trim().length > 0) {
          const targetField = parse({
            local,
            markup: stepField.dynamicFieldName,
            actionSequenceExecutionHistory: history,
            data: {
              ...data,
              ...inputs
            },
            params
          });
          newData[targetField] = stepFieldValue;
        } else if (stepField.fieldType === 'datetime') {
          if (stepFieldValue !== undefined && stepFieldValue !== '') {
            try {
              let dt = new Date(stepFieldValue);
              dt = Timestamp.fromDate(dt);
              if (!isNaN(dt.seconds) && !isNaN(dt.nanoseconds)) {
                newData[
                  stepField.dynamicFieldName?.trim().length > 0
                    ? stepField.dynamicFieldName
                    : stepField.name
                ] = dt;
              }
            } catch {
              // na
            }
          }
        } else if (
          stepField.fieldType === 'image' ||
          stepField.fieldType === 'file'
        ) {
          if (stepFieldValue !== undefined && stepFieldValue !== '') {
            newData[
              stepField.dynamicFieldName?.trim().length > 0
                ? stepField.dynamicFieldName
                : stepField.name
            ] = [{ original: stepFieldValue, thumb: stepFieldValue }];
          }
        } else {
          newData[
            stepField.dynamicFieldName?.trim().length > 0
              ? stepField.dynamicFieldName
              : stepField.name
          ] = stepFieldValue;
        }
      });

    step.fields
      ?.filter(f => f.value === '{delete}')
      .forEach(stepField => {
        if (stepField.dynamicFieldName?.trim().length > 0) {
          const targetField = parse({
            local,
            markup: stepField.dynamicFieldName,
            actionSequenceExecutionHistory: history,
            data: {
              ...data,
              ...inputs
            },
            params
          });
          newData[targetField] = deleteField();
        } else {
          newData[stepField.name] = deleteField();
        }
      });

    const path = getDataLinkPath({
      dataLink: pageDataLink.dataLink,
      documents,
      selections,
      user,
      local,
      dataLinks,
      data,
      params
    });

    if (newData.deleted === undefined) {
      newData.deleted = false;
    }
    if (newData.sortOrder === undefined) {
      newData.sortOrder = 1;
    }
    newData.lastUpdatedBy = user?.email ? user.email : 'unknown';
    newData.updatedAt = serverTimestamp();

    // replace any "true" or "false" with proper booleans
    Object.keys(newData).forEach(key => {
      if (newData[key]?.toLowerCase) {
        if (newData[key].toLowerCase().trim() === 'true') {
          newData[key] = true;
        } else if (newData[key].toLowerCase().trim() === 'false') {
          newData[key] = false;
        }
      }
    });

    const db = getDb(pageDataLink.dataLinkId);
    const databaseId = getDatabaseId(pageDataLink.dataLinkId);
    await updateDoc(doc(db, path, document.id), newData);

    if (step.logDocumentEvent) {
      await logDocumentEvent({
        db: getFirestore(),
        databaseId,
        contentTypeName: contentType.type,
        documentAction: 'onDocumentUpdated',
        documentId: document.id,
        path: `${path}/${document.id}`,
        before: document,
        after: newData,
        source: `actions.steps.update:\r\npage.id: ${page.id}\r\npage.name: ${page.name}\r\nsequence.id: ${sequence.id}\r\nsequence.name: ${sequence.name}\r\nstep.id: ${step.id}\r\nstep.name: ${step.name}`
      });
    }

    // only required since we are running this step in a closure and need other steps to be able to see updates
    //  before redux completes updates
    const index = documents[pageDataLink.dataLinkId]?.documents?.findIndex(
      d => d.id === document.id
    );
    if (index > -1) {
      documents[pageDataLink.dataLinkId].documents[index] = {
        ...document,
        ...newData
      };
    }

    /*
    await onDocumentAction({
      action: AUTOMATION_ACTION_TYPE.RECORD_UPDATED,
      id: document.id,
      contentType: pageDataLink.dataLink.contentType,
      document: documents[pageDataLink.dataLinkId].documents[index],
      path: `${path}/${document.id}`
    });
    */

    /*
      remove the document from search results
    */
    if (
      local &&
      step.searchLocalStoreKeyName?.trim().length > 0 &&
      local[step.searchLocalStoreKeyName] !== undefined &&
      Object.keys(local[step.searchLocalStoreKeyName].pages).length > 0
    ) {
      const search = { ...local[step.searchLocalStoreKeyName] };
      let hasChanges = false;

      Object.keys(search.pages).forEach(pageName => {
        let index = search.pages[pageName].results.findIndex(
          d => d.id === document.id
        );
        if (index > -1) {
          search.pages[pageName].results[index] = newData;
          hasChanges = true;
        }
        index = search.page.results.findIndex(d => d.id === document.id);
        if (index > -1) {
          search.page.results[index] = newData;
          hasChanges = true;
        }
      });

      if (hasChanges) {
        dispatch(keyUpdatedAction(step.searchLocalStoreKeyName, search));
      }
    }

    return newData;
  };

  return {
    updateDocument
  };
};

export default useUpdate;
